import './sign-in-form.styles.scss';
import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import RoundedBox from '../rounded-box/rounded-box.component';
import FormField from '../form-field/form-field.component';
import Loader from '../loader/loader.component';
import { authenticateUser } from '../../service/authentication.service';
import { UserContext } from '../../context/user.context';
import { CheckoutContext } from '../../context/checkout.context';

const defaultFormFields = {
    email: '',
    password: '',
}

const SignInForm = () => {
    const [errorMessage, setErrorMessage] = useState('');
    const [formFields, setFormFields] = useState(defaultFormFields);
    const [isLoading, setIsLoading] = useState(false);
    const { email, password } = formFields;

    const navigate = useNavigate();
    const { setCurrentUser } = useContext(UserContext);
    const { selectedInsurance } = useContext(CheckoutContext);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormFields({ ...formFields, [name]: value});
    };

    const handleSignUpClick = () => {
        navigate('/registration');
    }
    
    const handleForgotPassword = () => {
        navigate('/forgot-password');
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        setIsLoading(true);
        const user = await authenticateUser(email, password);
        setIsLoading(false);

        if (user instanceof Object) {
            setErrorMessage('');
            setCurrentUser(user);

            if (!!selectedInsurance?.insuranceName) {
                navigate('/checkout')
            } else {
                navigate('/');
            }
        } else {
            setErrorMessage('E-mail ou senha incorretos!');
        }
    };
    return (
        <div>
            {
                isLoading ? (
                    <Loader/>
                ) : (
                    <RoundedBox className='sign-in-form-container'>
                        <form className='sign-in-form' onSubmit={handleSubmit}>
                            <label className='title'>Entre com a sua conta:</label>
                            <FormField
                                darkBackground
                                label='E-mail'
                                name='email'
                                type='email'
                                required
                                value={email}
                                onChange={handleChange}
                                errorMessage={errorMessage}/>
                            <FormField
                                darkBackground
                                label='Senha'
                                name='password'
                                type='password'
                                required
                                value={password}
                                onChange={handleChange}
                                errorMessage={errorMessage}/>
                            <div className='footer'>
                                <Button
                                    type='submit'
                                    className='sign-in button'
                                    variant='contained'>
                                    Entrar
                                </Button>
                            </div>
                            <div className='forgot-password-button' onClick={handleForgotPassword}>
                                <label>
                                    Esqueci minha senha
                                </label>
                            </div>
                            <div className='sign-up-prompt'>
                                Não tem uma conta?{' '}
                                <span className='sign-up-link' onClick={handleSignUpClick}>
                                    Cadastre-se aqui
                                </span>
                            </div>
                        </form>
                    </RoundedBox>
                )
            }
        </div>
    )
}

export default SignInForm;